module.exports = __webpack_public_path__ + "static/media/simi-resume.9e9860ab.pdf";